import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Serializer, SerializerResponse, Serializers} from "../interfaces/serializer";
import {map} from 'rxjs/operators';
import {AppService} from "./app.service";
import {DataSource} from "../interfaces/data-source";
import {SerializerUtils} from '../libraries/serializer-utils';
import {Site} from '../interfaces/site';
import {DataSourceProvider} from '../store/dataSourceProviders/dataSourceProviders';

@Injectable()
export class DataSourcesService {
  private readonly baseUrl = environment.baseUrl;

  constructor(
    private _http: HttpClient,
    private _appS: AppService
  ) {}

  public getSetupLink(dataSource: Serializer<DataSource>): string {
    if (dataSource.attributes.with_auth_token) {
      return this._appS.user.attributes.token+'/'+this._appS.datasetID+'/data-sources/'+dataSource.id+'/start';
    } else {
      return this._appS.datasetID+'/data-sources/'+dataSource.id+'/start';
    }
  }

  public getDataSources(dataset: Serializer<Site>): Observable<Serializers<DataSource>> {
    return this._http.get<SerializerResponse<Serializers<DataSource>>>(this.baseUrl + '/api/' + dataset.id + '/data-sources')
      .pipe(
        map((data_sources: SerializerResponse<Serializers<DataSource>>) => {
          SerializerUtils.joinRelationships(data_sources, ['data_source_group']);
          return data_sources.data
        }));
  }

  public getDataSourceProvider(dataset: Serializer<Site>): Observable<SerializerResponse<Serializers<DataSourceProvider>>> {
    return this._http.get<SerializerResponse<Serializers<DataSourceProvider>>>(`${environment.baseUrl}/api/${dataset.id}/data-source-providers`);
  }

}
